import { __awaiter, __generator } from "tslib";
export function getSearchMiddleTierEnvironment(searchEnvironmentPromise) {
    return __awaiter(this, void 0, void 0, function () {
        var searchEnvironment;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, searchEnvironmentPromise];
                case 1:
                    searchEnvironment = _a.sent();
                    switch (searchEnvironment) {
                        case 'test':
                            return [2 /*return*/, 'Df'];
                        case 'prodbubble':
                            return [2 /*return*/, 'Msit'];
                        case 'gcc':
                            return [2 /*return*/, 'GccModerate'];
                        case 'pathfinder':
                            return [2 /*return*/, 'DoD'];
                        case 'trailblazer':
                            return [2 /*return*/, 'GccHigh'];
                        case 'prod':
                            return [2 /*return*/, 'Prod'];
                        default:
                            return [2 /*return*/, 'Unknown'];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=getSearchMiddleTierEnvironment.js.map